module.exports = "/images/logo.png?0cb2e7ecdf8b656b4081f10805102b1d";